export enum modules {
    ALLOW = 'allow',
    DOCUMENTS_LIBRARY = 'documentLibrary',
    PERFORMANCE = 'performance',
    TIME_OFF = 'timeOff',
    TOIL = "toil",
    TALENT = 'talent',
    BUSINESS_RULE_AUTOMATION = 'ruleAutomation',
    LETTERS = 'letters',
}
